<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1VwKh0/tc-custom/9781466869301.jpg?1729034268016" alt="This image is the cover for the book Unnoticeables, The Vicious Circuit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unnoticeables, The Vicious Circuit
      </h1>
      <p class="bookDescription body article font2">
        <b>Filled with “irreverent wit” this urban fantasy novel is a “raunchy, rollicking tale of punk rock, gruesome horror and pop-culture satire” (<i>NPR</i>).</b><br/><br/>There are angels, and they are not beneficent or loving. But they do watch over us. They watch our lives unfold, analyzing us for repeating patterns and redundancies. When they find them, the angels simplify those patterns and remove the redundancies, and the problem that is “you” gets solved.<br/><br/>Carey doesn’t much like that idea. As a punk living in New York City, 1977, Carey is sick and tired of watching strange kids with unnoticeable faces abduct his friends. He doesn’t care about the rumors of tar-monsters in the sewers or unkillable psychopaths invading the punk scene—all he wants is to drink cheap beer and dispense ass-kickings.<br/><br/>Kaitlyn isn’t sure what she’s doing with her life. She came to Hollywood in 2013 to be a stunt woman, but last night a former teen heartthrob tried to eat her, her best friend has just gone missing, and there’s an angel outside her apartment. Whatever she plans on doing with her life, it should probably happen in the few remaining minutes she has left.<br/><br/>There are angels. There are demons. They are the same thing. It’s up to Carey and Kaitlyn to stop them. The survival of the human race is in their hands.<br/><br/>We are, all of us, well and truly screwed.<br/><br/>“A nasty, freaky, and haphazardly funny horror story.” —<i>Kirkus Reviews</i><br/><br/>“Strangely readable, with unexpected depths.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Brockway
      </h2>
      
      <p class="authorDescription body article">ROBERT BROCKWAY is a Senior Editor and columnist for Cracked.com. He lives in Portland, Oregon, with his wife Meagan and their two dogs, Detectives Martin Riggs and Roger Murtaugh. He has been known, on occasion, to have a beard. He is the author of <I>Everything is Going to Kill Everybody, The Empty Ones, </I>and <I>The Unnoticeables</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ed1461d0